import React from 'react';
import * as Ons from 'react-onsenui';
import { translate as _ } from '../../util/i18n';

class Scores extends React.Component {

    handleChange( team, period, type, e ) {

        const key          = 'periodScores' + team;
        const scores       = [ ...this.props.gameReportReferee[ key ] ];
        const periodScores = scores[ period ] || {};
        const lastPeriod   = this.props.config.periods.length - 1;

        this.props.config.types.forEach( t => {

            if ( t.key === type.key ) {

                let value = e.target.value === '' ? Number.NaN : Number( e.target.value );

                if ( isNaN( value ) ) {

                    value = null;

                } else {

                    value = Math.floor( value );

                }

                periodScores[ type.key ] = value;

            } else if ( ! ( t.key in periodScores ) ) {

                periodScores[ t.key ] = null;

            }

        } );

        scores[ period ] = periodScores;

        if ( period < lastPeriod ) {

            let total = null;

            scores.forEach( ( score, i ) => {

                if ( i < lastPeriod && score && ( type.key in score ) && score[ type.key ] !== null ) {

                    total += score[ type.key ];

                }

            } );

            scores[ lastPeriod ] = { ...scores[ lastPeriod ], [ type.key ]: total };

        }

        this.props.onChange( key, scores );

    }

    renderScores( team ) {

        return this.props.config && this.props.config.types.map( type =>

            <div className="row inputs" key={type.key}>

                <div>{_( type.title )}</div>

                {this.props.config.periods.map( ( period, i ) => {

                    const props = {

                        disabled: this.props.disabled,
                        modifier: 'underbar',
                        onChange: e => this.handleChange( team, i, type, e ),
                        type:    'number',
                        value:
                              this.props.gameReportReferee[ 'periodScores' + team ] &&
                            ( this.props.gameReportReferee[ 'periodScores' + team ].length >= i + 1 ) &&
                              this.props.gameReportReferee[ 'periodScores' + team ][ i ] &&
                            ( this.props.gameReportReferee[ 'periodScores' + team ][ i ][ type.key ] !== null )

                            ? String( this.props.gameReportReferee[ 'periodScores' + team ][ i ][ type.key ] )

                            : ''

                    };

                    if ( this.props.readonly ) {

                        props.readonly = true;

                    }

                    return (

                        <div key={i}><Ons.Input { ...props } /></div>

                    );

                } )}

            </div>

        );

    }

    render() {

        return (

            <div className="scores">

                <div className="row header">

                    <div></div>
                    { this.props.config && this.props.config.periods.map( ( period, i ) => <div key={i}>{period}</div> ) }

                </div>

                <div className="row">

                    <div className="team">{_( 'Heimteam' )}</div>

                </div>

                {this.renderScores( 'Home' )}

                <div className="row">

                    <div className="team">{_( 'Gastteam' )}</div>

                </div>

                {this.renderScores( 'Away' )}

            </div>

        );

    }

}

export default Scores;